import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/components/home/Home'
import AdminPages from '@/components/admin/AdminPages'
import Avisos from '@/components/cadastros/avisos/Avisos'
import Categorias from '@/components/cadastros/categorias/Categorias'
import Status from '@/components/cadastros/status/Statuss'
import Clas from '@/components/cadastros/clas/Clas'
import Locais from '@/components/cadastros/locais/Locais'
import TipoAtividades from '@/components/cadastros/tipoAtividades/Tipos'
import MotivoAtendimento from '@/components/cadastros/motivoAtendimentos/Motivos'
import TipoAtendimento from '@/components/cadastros/tipoAtendimentos/Tipos'
import PerfisAcessos from '@/components/cadastros/perfisAcessos/Perfis'
import Textos from '@/components/estudos/Textos'
import Cursos from '@/components/estudos/Cursos/Cursos'
import MinhasPublicacoes from '@/components/estudos/MinhasPublicacoes'
import Calendario from '@/components/calendario/Calendario'
import Iniciados from '@/components/iniciados/Iniciados'
import NovoIniciado from '@/components/iniciados/NovoIniciado'
import Perfil from '@/components/perfil/Perfil'
import Preferencias from '@/components/preferencias/Preferencias'
import Auth from '@/components/auth/Auth'
import NovaSenha from '@/components/auth/NovaSenha'
import ConfirmacaoAtendimento from '@/components/atendimento/fichas/ConfirmacaoAtendimento'
import {userKey} from '@/config/global'
import Pessoas from '@/components/atendimento/pessoas/Pessoas'
import Fichas from '@/components/atendimento/fichas/Fichas'
import store from './store.js'


Vue.use(VueRouter)

const routes = [
	{
		name: 'home',
		path: '/',
		component: Home,
	},
	{
		name: 'adminPages',
		path: '/admin',
		component: AdminPages,
		meta: {acesso: true, idItem: "2"}
	},
	{
		name: 'avisos',
		path: '/cavisos',
		component: Avisos,
		meta: {acesso: true, idItem: "3"}
	},
	{
		name: 'categorias',
		path: '/ccategorias',
		component: Categorias,
		meta: {acesso: true, idItem: "4"}
	},
	{
		name: 'clas',
		path: '/cclas',
		component: Clas,
		meta: {acesso: true, idItem: "5"}
	},
	{
		name: 'status',
		path: '/cstatus',
		component: Status,
		meta: {acesso: true, idItem: "6"}
	},
	{
		name: 'locais',
		path: '/clocais',
		component: Locais,
		meta: {acesso: true, idItem: "7"}
	},
	{
		name: 'tipoAtividades',
		path: '/ctipoatividades',
		component: TipoAtividades,
		meta: {acesso: true, idItem: "8"}
	},
	{
		name: 'motivoAtendimento',
		path: '/motivoatendimento',
		component: MotivoAtendimento,
		meta: {acesso: true, idItem: "9"}
	},
	{
		name: 'tipoAtendimento',
		path: '/tipoatendimento',
		component: TipoAtendimento,
		meta: {acesso: true, idItem: "10"}
	},
	{
		name: 'perfisAcessos',
		path: '/perfisacessos',
		component: PerfisAcessos,
		meta: {acesso: true, idItem: "11"}
	},
	{
		name: 'pessoas',
		path: '/pessoas',
		component: Pessoas,
		meta: {acesso: true, idItem: "12"}
	},
	{
		name: 'fichas',
		path: '/fichasAtendimento',
		component: Fichas,
		meta: {acesso: true, idItem: "13"}
	},
	{
		name: 'calendario',
		path: '/calendario',
		component: Calendario,
		meta: {acesso: true, idItem: "14"}
	},
	{
		name: 'textos',
		path: '/textos',
		component: Textos,
		meta: {acesso: true, idItem: "15"}
	},
	{
		name: 'minhasPublicacoes',
		path: '/minhasPublicacoes',
		component: MinhasPublicacoes,
		meta: {acesso: true, idItem: "16"}
	},
	{
		name: 'preferencias',
		path: '/preferencias',
		component: Preferencias,
		meta: {acesso: true, idItem: "17"}
	},
	{
		name: 'perfil',
		path: '/perfil',
		component: Perfil,
		meta: {acesso: true, idItem: "18"}
	},
	{
		name: 'iniciados',
		path: '/iniciados',
		component: Iniciados,
		meta: {acesso: true, idItem: "19"}
	},
	{
		name: 'novoIniciado',
		path: '/novoIniciado',
		component: NovoIniciado,
		meta: {acesso: true, idItem: "20"}
	},
	{
		name: 'auth',
		path: '/auth',
		component: Auth
	},
	{
		name: 'NovaSenha',
		path: '/novaSenha',
		component: NovaSenha
	},
	{
		name: 'ConfirmacaoAtendimento',
		path: '/confirmacaoAtendimento',
		component: ConfirmacaoAtendimento
	},
	{
		name: 'Cursos',
		path: '/cursos',
		component: Cursos,
		meta: {acesso: true, idItem: "36"}
	}

]

const router = new VueRouter({
	mode: 'history',
	routes
})

router.beforeEach((to, from, next) => {

	let idItem = 0

	if(to.matched.some(record => { 
		
			idItem = record.meta.idItem
			return record.meta.acesso
		})){
				
		//const acessos = JSON.parse(json).acessos
		const acessos = store.state.user.acessos
		const json = sessionStorage.getItem(userKey)
		if(json == null) {
			store.commit('setUser', null)
			next({name: 'auth'})
		}else{

		let acesso = acessos.some(v => {
				return v.id_item == idItem
			})

			acesso > 0 ? next() : next({path: '/'})
		}
	}else{
		next()
	}
	
})

export default router

